import { render, staticRenderFns } from "./no-site-administrable.vue?vue&type=template&id=0c4243df&"
import script from "./no-site-administrable.vue?vue&type=script&lang=js&"
export * from "./no-site-administrable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports